// FR-16 — emits front-of-funnel events for downstream analytics. The
// provider is OOS for this slice (chosen in
// [00-bootstrap/0b-third-party-services.md]); v1 logs to console so
// product can confirm event shapes during QA before wiring a real
// provider. PII (addresses) is hashed before send per the doc.

export type AnalyticsEvent =
  | { name: "home_viewed" }
  | { name: "category_viewed"; category_slug: string }
  | { name: "type_viewed"; type_slug: string }
  | { name: "search_performed"; query_length: number; result_count: number }
  | { name: "reserve_clicked"; type_slug: string }
  | { name: "service_area_checked"; address_hash: string };

export function track(event: AnalyticsEvent): void {
  if (typeof window === "undefined") return;
  // eslint-disable-next-line no-console
  console.info("[analytics]", event);
}

// Lightweight non-cryptographic hash for the analytics PII filter. The
// guarantee is "same address → same hash so we can dedupe", not
// "irreversible" — we don't need crypto for downstream funnel analysis.
export function hashAddress(address: string): string {
  const normalized = address.trim().toLowerCase();
  let h = 5381;
  for (let i = 0; i < normalized.length; i++) {
    h = ((h << 5) + h) ^ normalized.charCodeAt(i);
  }
  // Force to unsigned and base-36 for compactness.
  return ((h >>> 0).toString(36)).padStart(7, "0");
}
